let locks = 0
let savedOverflow = ''
let savedPadding = ''

export const lockBody = () => {
  if (locks++ > 0) return
  const { body } = document
  // ширина исчезнувшего скроллбара, чтобы страница не дёргалась вправо
  const gap = window.innerWidth - document.documentElement.clientWidth
  savedOverflow = body.style.overflow
  savedPadding = body.style.paddingRight
  body.style.overflow = 'hidden'
  if (gap > 0) body.style.paddingRight = `${gap}px`
}

export const unlockBody = () => {
  if (locks === 0 || --locks > 0) return
  const { body } = document
  body.style.overflow = savedOverflow
  body.style.paddingRight = savedPadding
}
